import { useState } from "react"
import { PopupContext } from "./PopupContext"

export const PopupProvider = ({ children }) => {

    const [visible, setVisible] = useState(false)

    return(
        <PopupContext.Provider value={{ visible, setVisible }}>
            { children }
        </PopupContext.Provider>
    )
}